import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorComponent } from './pages/error/error.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { MaterialModule } from './material/material.module';
import { GroupByPipe } from './pipes/group-by/group-by.pipe';
import { DateSelectorComponent } from './components/date-selector/date-selector.component';
import { WeekSelectorComponent } from './components/week-selector/week-selector.component';
import { QuantityDialogComponent } from './components/quantity-dialog/quantity-dialog.component';
import { EditTimecardDialogComponent } from './components/edit-timecard-dialog/edit-timecard-dialog.component';
import { CreateCreditCardDialogComponent } from './components/create-credit-card-dialog/create-credit-card-dialog.component';
import { FileUploadDialogComponent } from './components/file-upload-dialog/file-upload-dialog.component';
import { EditCreditCardDialogComponent } from './components/edit-credit-card-dialog/edit-credit-card-dialog.component';
import { CreditCardsListComponent } from './components/credit-cards-list/credit-cards-list.component';
import { InformDialogComponent } from './components/inform-dialog/inform-dialog.component';
import { AttachmentComponent } from './components/attachment/attachment.component';
import { PipesModule } from './pipes/pipes.module';
import { Time12hPipe } from './pipes/time-12h/time12h.pipe';
import { AttachmentListComponent } from './components/attachment-list/attachment-list.component';
import { SubmitValidationDialogComponent } from './components/submit-validation-dialog/submit-validation-dialog.component';
import { DashboardInspectionListComponent } from './components/dashboard-inspection-list/dashboard-inspection-list.component';
import { DashboardObservationListComponent } from './components/dashboard-observation-list/dashboard-observation-list.component';
import { BlobFileListComponent } from './components/blob-file-list/blob-file-list.component';
import { FileViewerComponent } from './components/file-viewer/file-viewer.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MaterialModule,
    FlexLayoutModule,
    PipesModule,
    NgxExtendedPdfViewerModule
  ],
  declarations: [
    ErrorComponent,
    NotFoundComponent,
    GroupByPipe,
    DateSelectorComponent,
    WeekSelectorComponent,
    QuantityDialogComponent,
    EditTimecardDialogComponent,
    CreateCreditCardDialogComponent,
    FileUploadDialogComponent,
    EditCreditCardDialogComponent,
    CreditCardsListComponent,
    InformDialogComponent,
    AttachmentComponent,
    Time12hPipe,
    AttachmentListComponent,
    SubmitValidationDialogComponent,
    DashboardInspectionListComponent,
    DashboardObservationListComponent,
    BlobFileListComponent,
    FileViewerComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MaterialModule,
    FlexLayoutModule,
    ErrorComponent,
    NotFoundComponent,
    GroupByPipe,
    DateSelectorComponent,
    WeekSelectorComponent,
    CreditCardsListComponent,
    AttachmentComponent,
    PipesModule,
    Time12hPipe,
    AttachmentListComponent,
    DashboardInspectionListComponent,
    DashboardObservationListComponent,
    BlobFileListComponent,
    FileViewerComponent,
  ]
})
export class SharedModule { }
